var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-60.3064,-576.787)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-347.44)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,603.373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.306,341.985C160.306,336.381 158.08,331.006 154.117,327.044C150.155,323.081 144.78,320.855 139.176,320.855L81.437,320.855C75.833,320.855 70.458,323.081 66.495,327.044C62.533,331.006 60.306,336.381 60.306,341.985L60.306,399.725C60.306,405.329 62.533,410.703 66.495,414.666C70.458,418.629 75.833,420.855 81.437,420.855L139.176,420.855C144.78,420.855 150.155,418.629 154.117,414.666C158.08,410.703 160.306,405.329 160.306,399.725L160.306,341.985Z",
    style: {
      fill: "#14606B"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-347.44)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01151,0,0,1.01151,-750.739,584.959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M884.196,370.079C884.196,360.067 876.08,351.951 866.068,351.951L836.55,351.951C826.538,351.951 818.422,360.067 818.422,370.079L818.422,399.597C818.422,409.609 826.538,417.725 836.55,417.725L866.068,417.725C876.08,417.725 884.196,409.609 884.196,399.597L884.196,370.079ZM878.841,370.079L878.841,399.597C878.841,406.652 873.123,412.37 866.068,412.37C866.068,412.37 836.55,412.37 836.55,412.37C829.496,412.37 823.777,406.652 823.777,399.597C823.777,399.597 823.777,370.079 823.777,370.079C823.777,363.025 829.496,357.306 836.55,357.306C836.55,357.306 866.068,357.306 866.068,357.306C873.123,357.306 878.841,363.025 878.841,370.079Z",
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-347.44)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.13019,0,0,1.13019,-851.807,542.457)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 866.984,
    cy: 366.364,
    r: 3.594,
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-347.44)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.73777,0,0,4.73777,-3997.27,-761.518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M866.984,362.769C868.968,362.769 870.578,364.38 870.578,366.364C870.578,368.347 868.968,369.958 866.984,369.958C865.001,369.958 863.39,368.347 863.39,366.364C863.39,364.38 865.001,362.769 866.984,362.769ZM866.984,363.913C868.337,363.913 869.435,365.011 869.435,366.364C869.435,367.716 868.337,368.814 866.984,368.814C865.632,368.814 864.533,367.716 864.533,366.364C864.533,365.011 865.632,363.913 866.984,363.913Z",
    style: {
      fill: "white"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.2b41a0d8.svg";
export { ForwardRef as ReactComponent };